import { render, staticRenderFns } from "./Item1.vue?vue&type=template&id=16881bf2&"
import script from "./Item1.vue?vue&type=script&lang=js&"
export * from "./Item1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports